import React from 'react';
import './ProgressBar.scss';

const ProgressBar = ({ barHeight, progressPercentage }) => {
  // null/undefined => indeterminate: fill the track with the animated stripes
  // and show no number (used when the file size is unknown).
  const indeterminate = progressPercentage == null;
  const width = indeterminate ? 100 : progressPercentage;
  return(
    <div className="progress" style={{ height: `${barHeight}px` }}>
      <div
        className="progress-bar progress-bar-striped progress-bar-animated bg-warning"
        role="progressbar"
        style={{ width: `${width}%` }}
        aria-valuenow={indeterminate ? undefined : `${progressPercentage}`}
        aria-valuemin="0"
        aria-valuemax="100">{indeterminate ? '' : `${progressPercentage}%`}</div>
    </div>
  )
}

export default ProgressBar;
